// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../settings.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.Table--secondaryLabelAlone--f8vEQ {
  font-weight: normal;
}

.Table--secondaryLabelWithMain--UBULD {
}

.Table--tooltipIcon--QcUKP {
  position: relative;
  margin-right: .75em;
  float: right;
}

.Table--tooltipIcon--QcUKP > img {
  width: 14px;
}

.Table--rowTooltipIcon--aOeE7 {
  margin-right: 0;
  margin-left: .75em;
  float: none;
}

.Table--rowTooltipIcon--aOeE7 > img {
  width: 14px;
}

.Table--TableTooltipWrapper--DKpZf {
  z-index: 1;
  position: relative;
}

@media print {

  .Table--secondaryLabelWithMain--UBULD {
    color: var(--text-black);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/common/Table.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EAEE,mBAAmB;AACrB;;AAEA;AAGA;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE;IAEE,wBAAwB;EAE1B;AACF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.secondaryLabelAlone {\n  composes: secondaryLeftPadding from '../settings.css';\n  font-weight: normal;\n}\n\n.secondaryLabelWithMain {\n  composes: lightText from '../../../styles/typography.css';\n  composes: secondaryLeftPadding from '../settings.css';\n}\n\n.tooltipIcon {\n  position: relative;\n  margin-right: .75em;\n  float: right;\n}\n\n.tooltipIcon > img {\n  width: 14px;\n}\n\n.rowTooltipIcon {\n  composes: tooltipIcon;\n  margin-right: 0;\n  margin-left: .75em;\n  float: none;\n}\n\n.rowTooltipIcon > img {\n  width: 14px;\n}\n\n.TableTooltipWrapper {\n  z-index: 1;\n  position: relative;\n}\n\n@media print {\n\n  .secondaryLabelWithMain {\n    composes: lightText largeSize from '../../../styles/typography.css';\n    color: var(--text-black);\n  \tcomposes: secondaryLeftPadding from '../settings.css';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secondaryLabelAlone": `Table--secondaryLabelAlone--f8vEQ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["secondaryLeftPadding"]}`,
	"secondaryLabelWithMain": `Table--secondaryLabelWithMain--UBULD ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightText"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["secondaryLeftPadding"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["secondaryLeftPadding"]}`,
	"tooltipIcon": `Table--tooltipIcon--QcUKP`,
	"rowTooltipIcon": `Table--rowTooltipIcon--aOeE7 Table--tooltipIcon--QcUKP`,
	"TableTooltipWrapper": `Table--TableTooltipWrapper--DKpZf`
};
export default ___CSS_LOADER_EXPORT___;
